import { Typography } from '@mui/material'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  MailAuthArtistForm,
  MailAuthArtistFormProps,
} from './MailAuthArtistForm'

export * from './fragments'

export type State = {
  loading: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: MailAuthArtistFormProps['onSubmit']
  onResendAuthMail: MailAuthArtistFormProps['onResendAuthMail']
}

export const MailAuthArtistTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onResendAuthMail,
}) => {
  const { t } = useTranslation('mailAuthArtist')
  const { routerNames } = useRouter()

  return (
    <>
      <Head title={routerNames.MailAuthArtist} />
      <BaseLayout margin header={{ back: true, title: t('title') }}>
        <Typography variant="body2" sx={{ py: 2 }}>
          {t('desc')}
        </Typography>
        <MailAuthArtistForm
          loading={state.loading}
          onSubmit={onSubmit}
          onResendAuthMail={onResendAuthMail}
        />
      </BaseLayout>
    </>
  )
}
